<div>
  <div class="top-strip">
      <span class="font-weight-600"> {{balancesmartemailcredits}} out of {{smartemailcredits}} </span> smart email credits available
  </div>
  <div class="modal-body px-5">
  <h6 class="modal-title font-weight-600 f-14 text-defualt mb-2">Send Email</h6>
    <div class="form-group mb-0">
      <form [formGroup]="bulkemail_Form">
        <div class="row mb-3">
          <div class="col-8">
            <div class="row mb-3" (click)="collapseALldiv()">
              <div class="col">
                <label for="from" class="f-12 mb-0">From <span class="text-danger">*</span>
                </label>
                <div class="col px-0 mt-2" *ngIf="integratedemailsarray && integratedemailsarray.length == 0">
                  <div class="d-flex justify-content-between col-12 px-0">

                    <div class="d-flex justify-content-between email-icons col mr-2 px-0" (click)="connectoGmail()">
                      <img src="assets/icons/Group 22@2x.png" alt="Google logo" class="mx-2" style="height: 30px;width: 30px;">
                      <span class="mr-auto" style="margin-left: 40px;">Connect Gmail</span>
                    </div>

                    <div class="d-flex justify-content-between email-icons col px-0" (click)="connectoOutlook()">
                      <img src="assets/icons/MICROSOFT-LOGO-SQUARE 1@2x.png" alt="Outlook logo" class="mx-2" style="height: 30px;width: 30px;">
                      <span class="mr-auto" style="margin-left: 40px;">Connect Outlook</span>
                    </div>
                  </div>

                  <div style="background-color: #f2f2f2;padding: 10px 14px;" class="mt-3">
                    <p class="mb-1 font-weight-500 f-12">
                      Webbtree will request access to your email in order to:
                    </p>
                    <p class="mb-2 f-12">
                     Reachout to the sourced candidates and explore a connection by sending the emails composed by you.
                    </p>

                    <p class="mb-1 f-12">
                      <i class="fas fa-info-circle mr-1" style="color:#ffd200">
                      </i> We strictly abide by our security and privacy policy in the best interest of our users.
                    </p>
                  </div>
                </div>
                <div class="position-relative">
                  <section *ngIf="integratedemailsarray && integratedemailsarray.length > 0">
                    <p-dropdown [options]="integratedemailsarray" formControlName="from"
                      (onChange)="selectFromEmail($event.value)" optionValue="integrationplatform"
                      [style]="{'width':'100%', 'top':'-8px'}">
                      <ng-template pTemplate="selectedItem">
                        <div class="country-item country-item-value">
                          <i class="fas fa-email"> </i>
                          <div> <img src={{selectedItem.icon}} style="width: 14px;height: 11px;" class="mr-2">
                            {{username}} <{{selectedItem.emailid}}>
                          </div>
                        </div>
                      </ng-template>
                      <ng-template let-item pTemplate="item">
                        <img src={{item.icon}} style="width: 14px;height: 11px;" class="mr-2">
                        <span> {{username}} </span>
                        <span>
                          <{{item.emailid}}>
                        </span>
                      </ng-template>
                    </p-dropdown>
                  </section>
                  <p class="text-danger f-12 pt-1"
                    *ngIf="bulkemail_Form['controls'].from.hasError('required') && (bulkemail_Form['controls'].from.dirty || bulkemail_Form['controls'].from.touched)">
                    From is required</p>
                </div>
              </div>

            </div>


            <div class="row mb-4">
              <div class="col">
                <label for="to" class="f-12">To <span class="text-danger">*</span>
                </label>
                <div class="position-relative">
                  <input data-testid="auto-app-intro-candidateemail-input-1" type="text" placeholder="Enter Subject" class="wc-form-control nobg"
                    formControlName="todisplay">
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col">
                <label for="to" class="f-12">Email Type Preferences
                </label>
                <div class="position-relative">
                  <span class="selectdrop-down position-absolute tr0 f-12 mt-1"><i
                      class="fas fa-chevron-down"></i></span>
                  <select data-testid="auto-app-intro-candidateemail-select-1" class="wc-form-control nobg" (change)="selectEmailType($event)">
                    <!-- <option [value]="null" disabled>Select email template</option> -->
                    <option *ngFor="let email of emailPrefrence" [value]="email">
                      {{email}}
                  </select>
                </div>
              </div>
            </div>

            <div class="row mb-4">
              <div class="col">
                <label for="to" class="f-12">Email template
                </label>
                <div class="position-relative">
                  <span class="selectdrop-down position-absolute tr0 f-12 mt-1"><i
                      class="fas fa-chevron-down"></i></span>
                  <select data-testid="auto-app-intro-candidateemail-select-2" class="wc-form-control nobg" (change)="selectedTemplateOption($event)">
                    <option [value]="null" disabled>Select email template</option>
                    <option *ngFor="let template of customtempList" [value]="template.templateid"  [selected]="template?.templateid == selectedtempalteid">
                      {{template.actionname}}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row mb-3">

              <div class="col">
                <label for="subject" class="f-12">Subject <span class="text-danger">*</span>
                </label>
                <div class="position-relative">
                  <input data-testid="auto-app-intro-candidateemail-input-2" type="text" placeholder="Enter Subject" class="wc-form-control nobg" #subject
                    (input)="getCursorPosition('subject');" (click)="getCursorPosition('subject');"
                    formControlName="subject">
                  <p class="text-danger f-12 pt-1"
                    *ngIf="bulkemail_Form['controls'].subject.hasError('required') && (bulkemail_Form['controls'].subject.dirty || bulkemail_Form['controls'].subject.touched)">
                    Subject is required</p>
                </div>
              </div>
            </div>

          </div>
          <div class="col-4 d-flex align-items-end px-3 mb-3" (click)="collapseALldiv()">

            <div class="position-relative">
              <label class="f-12">Placeholders</label>
              <span class="selectdrop-down position-absolute tr0 f-12 mt-6"><i class="fas fa-chevron-down"></i></span>
              <select data-testid="auto-app-intro-candidateemail-select-3" class="wc-form-control nobg position-relative" [disabled]="!placeid"
                (change)="selectplaceholder($event)">
                <option value=null [selected]='!placeid'>Select placeholder</option>
                <option *ngFor="let x of placeholderlist" [value]="x.value">{{x.value}}</option>
              </select>
            </div>
          </div>

        </div>
        <div class="row mb-6" (click)="collapseALldiv()">
          <div class="col">
            <label for="emaiteplate" class="f-12">Email Template body <span class="text-danger">*</span>
            </label>
            <div>
              <!-- <angular-editor id="template" [config]="editorConfig" name="template" formControlName="emailtemplate"
                (input)="getCursorPosition('body');" (click)="getCursorPosition('body');">
              </angular-editor> -->
              <p-editor formControlName="emailtemplate" [style]="{'height':'250px'}" id="template" (onTextChange)="getCursorPosition('body');" (click)="getCursorPosition('body');">
                    <ng-template pTemplate="header">
                  <span class="ql-formats">
                    <select data-testid="auto-app-intro-candidateemail-select-4" class="ql-size">
                      <option value="small">Tiny</option>
                      <option selected></option>
                      <option value="large">Subheading</option>
                      <option value="huge">Heading</option>
                    </select>
                  </span>
                  <span class="ql-formats">
                    <button data-testid="auto-app-intro-candidateemail-button-1" type="button" class="ql-bold" aria-label="Bold"></button>
                    <button data-testid="auto-app-intro-candidateemail-button-2" type="button" class="ql-italic" aria-label="Italic"></button>
                    <button data-testid="auto-app-intro-candidateemail-button-3" type="button" class="ql-underline" aria-label="Underline"></button>
                    <button data-testid="auto-app-intro-candidateemail-button-4" type="button" class="ql-list" aria-label="Unordered list" value="bullet"></button>
                    <button data-testid="auto-app-intro-candidateemail-button-5" type="button" class="ql-link" aria-label="Insert link"  (click)="testscript()"></button>
                    <button data-testid="auto-app-intro-candidateemail-button-6" type="button" class="ql-clean" aria-label="Remove Styles"></button>
                </span>
                <span class="ql-formats">
                  <select data-testid="auto-app-intro-candidateemail-select-5" title="Text Alignment" class="ql-align" >
                    <option selected>Gauche</option>
                    <option value="center" label="Center"></option>
                    <option value="right" label="Right"></option>
                    <option value="justify" label="Justify"></option>
                  </select>            
                </span> 
                <span class="ql-formats">
                  <button data-testid="auto-app-intro-candidateemail-button-7" aria-label="Link" class="ql-link"></button>
                </span>
                </ng-template>
            </p-editor>
            <p *ngIf="bulkemail_Form['controls'].emailtemplate.hasError('scriptTagError')" [ngClass]="['text-left','my-1','text-danger']">
              Script tags are not allowed</p>
              <p class="text-danger f-12 pt-1"
                *ngIf="bulkemail_Form['controls'].emailtemplate.hasError('required') && (bulkemail_Form['controls'].emailtemplate.dirty || bulkemail_Form['controls'].emailtemplate.touched)">
                Email body is required</p>
            </div>
          </div>

        </div>
        <div class="mb-4">
          <div class="col d-flex align-items-center px-0">
            <span>Attachment</span>
            <div class="ml-2 p-0 uploadFile wc-form-control" style="width: 150px;">
              <input data-testid="auto-app-intro-candidateemail-input-3" type="file" class=" nobg" name="
                                  cvupload" id="cv" (change)="uploadFile($event)"
                accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">
              <span class="pointer">Choose your file</span>
            </div>
            <span class="text-9696 ml-3 f-12">( Uploaded document will reflect on candidate's documents )</span>
          </div>
          <!-- <div class="d-flex align-items-center"> -->
          <p *ngIf="special_char_error== true" [ngClass]="['text-left','my-1','text-danger']">
            File should not contain any special characters.</p>
          <p [ngClass]="['text-left','my-1','text-danger']" *ngIf="incorrectdoc==true">File type should be .doc
            .pdf .docx .txt</p>
          <p [ngClass]="['text-left','my-1','text-danger']" *ngIf="filesizeExceeded==true">File size should not exceed
            more then 5 mb</p>
          <!-- </div> -->

        </div>
        <div class="row">
          <div class="col">
            <span *ngFor="let doc of uploadedFiles" class="wc-ats-chip mr-2 mb-2 d-inline-block">{{doc.filename}}
              <span class="ml-2 pointer " (click)="removeFile(doc)"><i class="fas fa-times-circle"></i></span>
            </span>
          </div>
        </div>
      </form>
    </div>
  </div>
  <div class="modal-footer b pb-5">
    <div class="col-md-8 d-flex mx-auto" style="justify-content: center;">
      <button data-testid="auto-app-intro-candidateemail-button-8" class="btn-trms-white mx-4" (click)="modalService.dismissAll()">Close</button> 
      <button data-testid="auto-app-intro-candidateemail-button-9" type="button" class="btn-trms-small mx-4" data-dismiss="modal" [ngClass]="{'disabled-btn' : !bulkemail_Form?.valid}"  
        [matTooltip]="integratedemailsarray?.length == 0 ? 'Connect your inbox and explore connection' : null" [matTooltipClass]="{ 'red-tooltip': true }"  matTooltipPosition="right"
        (click)="getSingleCandidateCSEResult();">Send
      </button>
    </div>
  </div>
</div>

<ng-template #error class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-intro-candidateemail-button-10" type="button" class="close position-absolute tr0" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/error-vector.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">ERROR</p>
          <p class="text-center">{{error_message}}</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-intro-candidateemail-button-11" class="btn-trms-small m-auto" (click)="modalService.dismissAll()">CLOSE</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noEmailModal class="modal reloginmodal">
  <div class="modal-content">
    <div class="modal-body px-6 pb-6 pt-3">
      <div class="row mb-3">
        <div class="col pb-5">
          <button data-testid="auto-app-intro-candidateemail-button-12" type="button" class="close position-absolute tr0 font-weight-normal" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col text-center">
          <img src="./../../../assets/images/unauthorised.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="text-center">Please select atleast one candidate with an email id</p>
        </div>
      </div>
      <div class="row">
        <div class="col-md-10 mx-auto d-flex">
          <button data-testid="auto-app-intro-candidateemail-button-13" class="btn-trms-white m-auto"
            (click)="modalService.dismissAll()">Done</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #successModal class="modal">
  <div class="modal-content">
    <div class="modal-body py-2 px-6">
      <div class="row mb-3">
        <div class="col pl-1 d-flex justify-content-between">
          <span class="font-weight-600 dropdown-item px-0" style="pointer-events: none;">
            <i class="fas fa-check-circle mr-1" style="color: #229300;"></i> Successful!
          </span>
          <button data-testid="auto-app-intro-candidateemail-button-14" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col text-center">
          <img src="./../../../assets/images/Screenshot 2022-02-22 at 9.40 2.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="mb-3 f-14">Hurray! Email sent successfully <span *ngIf="candidateName"> send to <span class="font-weight-600">
            {{candidateName}}
          </span></span></p>
          <p class="mb-1 text-bluex f-14 font-weight-600 pointer" (click)="redirecToSentBox()">Check in your inbox</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>


<ng-template #BulksuccessModal class="modal">
  <div class="modal-content">
    <div class="modal-body py-2 px-6">
      <div class="row mb-0">
        <div class="col px-1 d-flex justify-content-between">
          <span class="font-weight-600 dropdown-item px-0" style="pointer-events: none;">
            <i class="fas fa-exclamation-circle mr-1" style="color: #ffd200;"></i> Sending emails in progress!
          </span>
          <button data-testid="auto-app-intro-candidateemail-button-15" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col text-center">
          <img src="./../../../assets/New Message_Two Color 1.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-4">
        <div class="col">
          <p class="mb-1 f-14">Emails will be sent to the selected candidates, you will receive an update on your email id soon!</p>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #noPersonalFound class="modal">
  <div class="modal-content">
    <div class="modal-body py-2 px-6">
      <div class="row">
        <div class="col px-1 d-flex justify-content-between">
          <span class="font-weight-600 dropdown-item px-0" style="pointer-events: none;">
            <i class="fas fa-exclamation-circle mr-1" style="color:#ffd200"> </i> Almost there!
          </span>
          <button data-testid="auto-app-intro-candidateemail-button-16" type="button" class="close font-weight-normal" data-dismiss="modal" aria-label="Close"
            (click)="modalService.dismissAll()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col text-center">
          <img src="./../../../assets/images/Empty Inbox _Two Color 2.png" alt="img-fluid">
        </div>
      </div>
      <div class="row mb-2">
        <div class="col">
          <p class="mb-3 f-14">Hang tight! We are looking for the
             <span class="font-weight-600" *ngIf="selected_emailpreference == 'Personal Only'">Personal</span> 
             <span class="font-weight-600" *ngIf="selected_emailpreference == 'Professional only'">Professional</span> 
             email id of <span class="font-weight-600" *ngIf="candidateName">{{candidateName}}</span></p>
          <p class="mb-0 f-14">You will be notified when the email id is found in the next 72 Hours.</p>

          <section *ngIf="singleCandidateDetails?.professional_email?.length" class="mt-3">
            <hr>
            <p class="f-12 mt-2">Send to their <span class="font-weight-600">Professional</span> email id instead? </p>
            <div class="d-flex text-center justify-content-between mx-auto">
              <button data-testid="auto-app-intro-candidateemail-button-17" class="m-auto btn-trms-white"
                (click)="modalService.dismissAll()">Cancel</button>
              <button data-testid="auto-app-intro-candidateemail-button-18" class="btn-trms-small m-auto"
                (click)="sendEmail('single','professional');">Send</button>
            </div>
          </section>

          <section *ngIf="singleCandidateDetails?.personal_email?.length" class="mt-2">
            <hr>
            <p class="f-12 mt-2">Send to their <span class="font-weight-600">Personal</span> email id instead? </p>
            <div class="d-flex text-center justify-content-between mx-auto">
              <button data-testid="auto-app-intro-candidateemail-button-19" class="m-auto btn-trms-white"
                (click)="modalService.dismissAll()">Cancel</button>
              <button data-testid="auto-app-intro-candidateemail-button-20" class="btn-trms-small m-auto"
                (click)="sendEmail('single','primary');">Send</button>
            </div>
          </section>

          <section
            *ngIf="!singleCandidateDetails?.emails?.length && (singleCandidateDetails?.contactnumbers?.length || singleCandidateDetails?.socialprofiles?.length)">
            <hr>
            <p class="mb-2 font-weight-500 f-14"> Reachout with other details found: </p>
            <p class="d-flex contacts-div mb-2"
              *ngFor="let contact of singleCandidateDetails?.contactnumbers?.slice(0,2);let i = index">
              <i class="far fa-phone-alt text-9696 f-12"></i>
              <span class="mx-2 text-truncate f-12">{{contact?.contactdetail}}</span>
              <span class="text-bluex f-12 mr-2 font-weight-500 pointer" id="contact_viewmore{{j}}"
                (click)="viewMore(j,'contact')" *ngIf="singleCandidateDetails?.contactnumbers?.length > 2 && i == 1"> +
                {{singleCandidateDetails?.contactnumbers?.length - 2 }} </span>
              <span *ngIf="!contact?.contactdetail?.includes('***')"
                (click)="copyDATA(contact?.contactdetail,contact.candidatecontactdetailid)"><i
                  class="fas fa-copy text-bluex f-12 copy-icon mr-2"></i></span>
              <span class="ml-auto">
                <span class='fa-stack mr-1' style="font-size: 6px;margin-bottom: 2px;" *ngIf="contact?.piplenriched">
                  <i class='fas fa-circle fa-stack-2x' style="font-size :12px;color: #af2c2c;"></i>
                  <i class='fas fa-star fa-stack-1x fa-inverse' style="font-size: 8px;"></i>
                </span>
                <i class="far fa-user-crown mr-1 f-12" *ngIf="contact?.contactdetailcategory == 'personal'"
                  title="personal" style="color:#229300"></i>
                <i class="far fa-user-check mr-1 f-12" *ngIf="contact?.isprimary" title="primary"
                  style="color:#50bfa5"></i>
                <i *ngIf="contact?.pipl_lastseen" class="far fa-eye mr-1 f-12" matTooltip="{{formatDATE(contact)}}"
                  [matTooltipClass]="{ 'red-tooltip': true }" style="color:#969696"></i>
              </span>
            </p>
            <section id="contact{{j}}" class="d-none">
              <p class="contacts-div mb-2 d-flex"
                *ngFor="let contact of singleCandidateDetails?.contactnumbers?.slice(2,singleCandidateDetails?.contactnumbers.length);let i = index">
                <i class="far fa-phone-alt text-9696 f-12"></i>
                <span class="mx-2 text-truncate f-12">{{contact?.contactdetail}}</span>
                <span *ngIf="!contact?.contactdetail?.includes('***')"
                  (click)="copyDATA(contact?.contactdetail,contact.candidatecontactdetailid)"><i
                    class="fas fa-copy text-bluex f-12 copy-icon mr-2"></i></span>
                <span class="ml-auto">
                  <span class='fa-stack mr-1' style="font-size: 6px;margin-bottom: 2px;" *ngIf="contact?.piplenriched">
                    <i class='fas fa-circle fa-stack-2x' style="font-size :12px;color: #af2c2c;"></i>
                    <i class='fas fa-star fa-stack-1x fa-inverse' style="font-size: 8px;"></i>
                  </span>
                  <i class="far fa-user-crown mr-1 f-12" *ngIf="contact?.contactdetailcategory == 'personal'"
                    title="personal" style="color:#229300"></i>
                  <i class="far fa-user-check mr-1 f-12" *ngIf="contact?.isprimary" title="primary"
                    style="color:#50bfa5"></i>
                  <i *ngIf="contact?.pipl_lastseen" class="far fa-eye mr-1 f-12" matTooltip="{{formatDATE(contact)}}"
                    [matTooltipClass]="{ 'red-tooltip': true }" style="color:#969696"></i>
                </span>
              </p>
              <p class="text-bluex font-weight-500 f-12 pointer mb-2" (click)="viewLess(j,'contact')"> view
                less </p>
            </section>

            <p class="d-flex text-truncate">
              <a data-testid="auto-app-intro-candidateemail-a-1" class="f-12 text-black mr-2" *ngFor="let link of singleCandidateDetails?.socialprofiles"
                target="_blank" href="{{link?.link}}" [ngClass]="{'p-none' : link?.link.includes('****')}"
                title="{{getSocialProfileIcon(link?.platformname).platformNameToBeDisplayed}}">
                <i class="{{getSocialProfileIcon(link?.platformname).iconToBeShown}}"
                  [ngClass]="{'text-9696 p-none' : link?.link.includes('****')}"></i></a>
            </p>

          </section>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ngb-alert class="ngb-alert" *ngIf="errorMessage" type="danger" (close)="errorMessage = ''">
  <span class="errorCheck"><i class="fal fa-times"></i></span>
  <span class="errormsg"> {{ errorMessage }} </span>
</ngb-alert>
